/**
 * Default cover images for countries
 * Uses high-quality Unsplash images with stable URLs
 * Multiple images per country for variety
 */

const defaultCoverImages: Record<string, string[]> = {
  // Europe
  "France": [
    "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&q=80",
    "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=1200&q=80",
    "https://images.unsplash.com/photo-1431274172761-fca41d930114?w=1200&q=80",
  ],
  "Italie": [
    "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=1200&q=80",
    "https://images.unsplash.com/photo-1534445867742-43195f401b6c?w=1200&q=80",
    "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=1200&q=80",
  ],
  "Italy": [
    "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=1200&q=80",
    "https://images.unsplash.com/photo-1534445867742-43195f401b6c?w=1200&q=80",
    "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=1200&q=80",
  ],
  "Espagne": [
    "https://images.unsplash.com/photo-1509840841025-9088ba78a826?w=1200&q=80",
    "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?w=1200&q=80",
    "https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=1200&q=80",
  ],
  "Spain": [
    "https://images.unsplash.com/photo-1509840841025-9088ba78a826?w=1200&q=80",
    "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?w=1200&q=80",
    "https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=1200&q=80",
  ],
  "Portugal": [
    "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80",
    "https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=1200&q=80",
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=80",
  ],
  "Grèce": [
    "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=1200&q=80",
    "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=1200&q=80",
    "https://images.unsplash.com/photo-1555993539-1732b0258235?w=1200&q=80",
  ],
  "Greece": [
    "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=1200&q=80",
    "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=1200&q=80",
    "https://images.unsplash.com/photo-1555993539-1732b0258235?w=1200&q=80",
  ],
  "Croatie": [
    "https://images.unsplash.com/photo-1555990538-1e6c0c4a1e03?w=1200&q=80",
    "https://images.unsplash.com/photo-1596098045498-3a6e1a58ddcd?w=1200&q=80",
    "https://images.unsplash.com/photo-1504575627704-5d3f32f0f48a?w=1200&q=80",
  ],
  "Croatia": [
    "https://images.unsplash.com/photo-1555990538-1e6c0c4a1e03?w=1200&q=80",
    "https://images.unsplash.com/photo-1596098045498-3a6e1a58ddcd?w=1200&q=80",
    "https://images.unsplash.com/photo-1504575627704-5d3f32f0f48a?w=1200&q=80",
  ],
  "Slovénie": [
    "https://images.unsplash.com/photo-1467541473380-93479a5a3ffa?w=1200&q=80",
    "https://images.unsplash.com/photo-1586016413664-864c0dd76f53?w=1200&q=80",
  ],
  "Slovenia": [
    "https://images.unsplash.com/photo-1467541473380-93479a5a3ffa?w=1200&q=80",
    "https://images.unsplash.com/photo-1586016413664-864c0dd76f53?w=1200&q=80",
  ],
  "Autriche": [
    "https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=1200&q=80",
    "https://images.unsplash.com/photo-1609856878074-cf31e21ccb6b?w=1200&q=80",
  ],
  "Austria": [
    "https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=1200&q=80",
    "https://images.unsplash.com/photo-1609856878074-cf31e21ccb6b?w=1200&q=80",
  ],
  "Suisse": [
    "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?w=1200&q=80",
    "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?w=1200&q=80",
    "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=80",
  ],
  "Switzerland": [
    "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?w=1200&q=80",
    "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?w=1200&q=80",
    "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=80",
  ],
  "Allemagne": [
    "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=1200&q=80",
    "https://images.unsplash.com/photo-1599946347371-68eb71b16afc?w=1200&q=80",
  ],
  "Germany": [
    "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=1200&q=80",
    "https://images.unsplash.com/photo-1599946347371-68eb71b16afc?w=1200&q=80",
  ],
  "Pays-Bas": [
    "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=1200&q=80",
    "https://images.unsplash.com/photo-1583425921350-6d16838c4c08?w=1200&q=80",
  ],
  "Netherlands": [
    "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=1200&q=80",
    "https://images.unsplash.com/photo-1583425921350-6d16838c4c08?w=1200&q=80",
  ],
  "Belgique": [
    "https://images.unsplash.com/photo-1559113202-c916b8e44373?w=1200&q=80",
    "https://images.unsplash.com/photo-1491557345352-5929e343eb89?w=1200&q=80",
  ],
  "Belgium": [
    "https://images.unsplash.com/photo-1559113202-c916b8e44373?w=1200&q=80",
    "https://images.unsplash.com/photo-1491557345352-5929e343eb89?w=1200&q=80",
  ],
  "Royaume-Uni": [
    "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1200&q=80",
    "https://images.unsplash.com/photo-1520986606214-8b456906c813?w=1200&q=80",
    "https://images.unsplash.com/photo-1529655683826-aba9b3e77383?w=1200&q=80",
  ],
  "United Kingdom": [
    "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1200&q=80",
    "https://images.unsplash.com/photo-1520986606214-8b456906c813?w=1200&q=80",
    "https://images.unsplash.com/photo-1529655683826-aba9b3e77383?w=1200&q=80",
  ],
  "Irlande": [
    "https://images.unsplash.com/photo-1590089415225-401ed6f9db8e?w=1200&q=80",
    "https://images.unsplash.com/photo-1564959130747-897a8e96a730?w=1200&q=80",
  ],
  "Ireland": [
    "https://images.unsplash.com/photo-1590089415225-401ed6f9db8e?w=1200&q=80",
    "https://images.unsplash.com/photo-1564959130747-897a8e96a730?w=1200&q=80",
  ],
  "Islande": [
    "https://images.unsplash.com/photo-1529963183134-61a90db47eaf?w=1200&q=80",
    "https://images.unsplash.com/photo-1474690870753-1b92efa1f2d8?w=1200&q=80",
    "https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=1200&q=80",
  ],
  "Iceland": [
    "https://images.unsplash.com/photo-1529963183134-61a90db47eaf?w=1200&q=80",
    "https://images.unsplash.com/photo-1474690870753-1b92efa1f2d8?w=1200&q=80",
    "https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=1200&q=80",
  ],
  "Norvège": [
    "https://images.unsplash.com/photo-1520769945061-0a448c463865?w=1200&q=80",
    "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=1200&q=80",
  ],
  "Norway": [
    "https://images.unsplash.com/photo-1520769945061-0a448c463865?w=1200&q=80",
    "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=1200&q=80",
  ],
  "Suède": [
    "https://images.unsplash.com/photo-1509356843151-3e7d96241e11?w=1200&q=80",
    "https://images.unsplash.com/photo-1508189860359-777d945909ef?w=1200&q=80",
  ],
  "Sweden": [
    "https://images.unsplash.com/photo-1509356843151-3e7d96241e11?w=1200&q=80",
    "https://images.unsplash.com/photo-1508189860359-777d945909ef?w=1200&q=80",
  ],
  "Finlande": [
    "https://images.unsplash.com/photo-1529154036614-a60975f5c760?w=1200&q=80",
    "https://images.unsplash.com/photo-1538332576228-eb5b4c4de6f5?w=1200&q=80",
  ],
  "Finland": [
    "https://images.unsplash.com/photo-1529154036614-a60975f5c760?w=1200&q=80",
    "https://images.unsplash.com/photo-1538332576228-eb5b4c4de6f5?w=1200&q=80",
  ],
  "Danemark": [
    "https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=1200&q=80",
    "https://images.unsplash.com/photo-1552560880-2482cef14240?w=1200&q=80",
  ],
  "Denmark": [
    "https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=1200&q=80",
    "https://images.unsplash.com/photo-1552560880-2482cef14240?w=1200&q=80",
  ],
  "Pologne": [
    "https://images.unsplash.com/photo-1519197924294-4ba991a11128?w=1200&q=80",
    "https://images.unsplash.com/photo-1607427293702-036933bbf746?w=1200&q=80",
  ],
  "Poland": [
    "https://images.unsplash.com/photo-1519197924294-4ba991a11128?w=1200&q=80",
    "https://images.unsplash.com/photo-1607427293702-036933bbf746?w=1200&q=80",
  ],
  "République tchèque": [
    "https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=1200&q=80",
    "https://images.unsplash.com/photo-1562624475-96c2bc08fab9?w=1200&q=80",
  ],
  "Czech Republic": [
    "https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=1200&q=80",
    "https://images.unsplash.com/photo-1562624475-96c2bc08fab9?w=1200&q=80",
  ],
  "Hongrie": [
    "https://images.unsplash.com/photo-1551867633-194f125bddfa?w=1200&q=80",
    "https://images.unsplash.com/photo-1549923746-c502d488b3ea?w=1200&q=80",
  ],
  "Hungary": [
    "https://images.unsplash.com/photo-1551867633-194f125bddfa?w=1200&q=80",
    "https://images.unsplash.com/photo-1549923746-c502d488b3ea?w=1200&q=80",
  ],
  "Roumanie": [
    "https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=1200&q=80",
  ],
  "Romania": [
    "https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=1200&q=80",
  ],
  "Bulgarie": [
    "https://images.unsplash.com/photo-1601284605844-81de3c728ee5?w=1200&q=80",
  ],
  "Bulgaria": [
    "https://images.unsplash.com/photo-1601284605844-81de3c728ee5?w=1200&q=80",
  ],
  "Monténégro": [
    "https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=1200&q=80",
    "https://images.unsplash.com/photo-1555990793-da11153b2473?w=1200&q=80",
  ],
  "Montenegro": [
    "https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=1200&q=80",
    "https://images.unsplash.com/photo-1555990793-da11153b2473?w=1200&q=80",
  ],
  "Albanie": [
    "https://images.unsplash.com/photo-1596402184320-417e7178b2cd?w=1200&q=80",
  ],
  "Albania": [
    "https://images.unsplash.com/photo-1596402184320-417e7178b2cd?w=1200&q=80",
  ],
  
  // Asia
  "Japon": [
    "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=1200&q=80",
    "https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=1200&q=80",
    "https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=1200&q=80",
  ],
  "Japan": [
    "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=1200&q=80",
    "https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=1200&q=80",
    "https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=1200&q=80",
  ],
  "Thaïlande": [
    "https://images.unsplash.com/photo-1528181304800-259b08848526?w=1200&q=80",
    "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=1200&q=80",
    "https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?w=1200&q=80",
  ],
  "Thailand": [
    "https://images.unsplash.com/photo-1528181304800-259b08848526?w=1200&q=80",
    "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=1200&q=80",
    "https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?w=1200&q=80",
  ],
  "Vietnam": [
    "https://images.unsplash.com/photo-1557750255-c76072a7aad1?w=1200&q=80",
    "https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=1200&q=80",
    "https://images.unsplash.com/photo-1528127269322-539801943592?w=1200&q=80",
  ],
  "Indonésie": [
    "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1200&q=80",
    "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=1200&q=80",
    "https://images.unsplash.com/photo-1570789210967-2cac24afeb00?w=1200&q=80",
  ],
  "Indonesia": [
    "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1200&q=80",
    "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=1200&q=80",
    "https://images.unsplash.com/photo-1570789210967-2cac24afeb00?w=1200&q=80",
  ],
  "Bali": [
    "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1200&q=80",
    "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=1200&q=80",
    "https://images.unsplash.com/photo-1570789210967-2cac24afeb00?w=1200&q=80",
  ],
  "Malaisie": [
    "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=1200&q=80",
    "https://images.unsplash.com/photo-1508062878650-88b52897f298?w=1200&q=80",
  ],
  "Malaysia": [
    "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=1200&q=80",
    "https://images.unsplash.com/photo-1508062878650-88b52897f298?w=1200&q=80",
  ],
  "Singapour": [
    "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=1200&q=80",
    "https://images.unsplash.com/photo-1508964942454-1a56651d54ac?w=1200&q=80",
  ],
  "Singapore": [
    "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=1200&q=80",
    "https://images.unsplash.com/photo-1508964942454-1a56651d54ac?w=1200&q=80",
  ],
  "Cambodge": [
    "https://images.unsplash.com/photo-1569060716907-60d3e82c1547?w=1200&q=80",
    "https://images.unsplash.com/photo-1540611025311-01df3cef54b5?w=1200&q=80",
  ],
  "Cambodia": [
    "https://images.unsplash.com/photo-1569060716907-60d3e82c1547?w=1200&q=80",
    "https://images.unsplash.com/photo-1540611025311-01df3cef54b5?w=1200&q=80",
  ],
  "Inde": [
    "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=80",
    "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=1200&q=80",
    "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=1200&q=80",
  ],
  "India": [
    "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=80",
    "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=1200&q=80",
    "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=1200&q=80",
  ],
  "Népal": [
    "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=1200&q=80",
    "https://images.unsplash.com/photo-1585019973907-8cbbc5f1d46e?w=1200&q=80",
  ],
  "Nepal": [
    "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=1200&q=80",
    "https://images.unsplash.com/photo-1585019973907-8cbbc5f1d46e?w=1200&q=80",
  ],
  "Sri Lanka": [
    "https://images.unsplash.com/photo-1546708973-b339540b5162?w=1200&q=80",
    "https://images.unsplash.com/photo-1580810734915-88c42bcb10b1?w=1200&q=80",
  ],
  "Chine": [
    "https://images.unsplash.com/photo-1547981609-4b6bfe67ca0b?w=1200&q=80",
    "https://images.unsplash.com/photo-1508804052814-cd3ba865a116?w=1200&q=80",
  ],
  "China": [
    "https://images.unsplash.com/photo-1547981609-4b6bfe67ca0b?w=1200&q=80",
    "https://images.unsplash.com/photo-1508804052814-cd3ba865a116?w=1200&q=80",
  ],
  "Corée du Sud": [
    "https://images.unsplash.com/photo-1538485399081-7191377e8241?w=1200&q=80",
    "https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=1200&q=80",
  ],
  "South Korea": [
    "https://images.unsplash.com/photo-1538485399081-7191377e8241?w=1200&q=80",
    "https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=1200&q=80",
  ],
  "Philippines": [
    "https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=1200&q=80",
    "https://images.unsplash.com/photo-1573790387438-4da905039392?w=1200&q=80",
  ],
  
  // Africa
  "Maroc": [
    "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=1200&q=80",
    "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?w=1200&q=80",
    "https://images.unsplash.com/photo-1548874892-64f8df224e1f?w=1200&q=80",
  ],
  "Morocco": [
    "https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=1200&q=80",
    "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?w=1200&q=80",
    "https://images.unsplash.com/photo-1548874892-64f8df224e1f?w=1200&q=80",
  ],
  "Égypte": [
    "https://images.unsplash.com/photo-1539768942893-daf53e448371?w=1200&q=80",
    "https://images.unsplash.com/photo-1568322445389-f64ac2515020?w=1200&q=80",
  ],
  "Egypt": [
    "https://images.unsplash.com/photo-1539768942893-daf53e448371?w=1200&q=80",
    "https://images.unsplash.com/photo-1568322445389-f64ac2515020?w=1200&q=80",
  ],
  "Afrique du Sud": [
    "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=1200&q=80",
    "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=1200&q=80",
  ],
  "South Africa": [
    "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=1200&q=80",
    "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=1200&q=80",
  ],
  "Kenya": [
    "https://images.unsplash.com/photo-1523805009345-7448845a9e53?w=1200&q=80",
    "https://images.unsplash.com/photo-1547970810-dc1eac37d174?w=1200&q=80",
  ],
  "Tanzanie": [
    "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=1200&q=80",
    "https://images.unsplash.com/photo-1535941339077-2dd1c7963098?w=1200&q=80",
  ],
  "Tanzania": [
    "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=1200&q=80",
    "https://images.unsplash.com/photo-1535941339077-2dd1c7963098?w=1200&q=80",
  ],
  "Namibie": [
    "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=1200&q=80",
    "https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=1200&q=80",
    "https://images.unsplash.com/photo-1503917988258-f87a78e3c995?w=1200&q=80",
  ],
  "Namibia": [
    "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=1200&q=80",
    "https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=1200&q=80",
    "https://images.unsplash.com/photo-1503917988258-f87a78e3c995?w=1200&q=80",
  ],
  "Madagascar": [
    "https://images.unsplash.com/photo-1580737074310-6af3c0a1d3b2?w=1200&q=80",
  ],
  "Tunisie": [
    "https://images.unsplash.com/photo-1590069261209-f8e9b8642343?w=1200&q=80",
    "https://images.unsplash.com/photo-1564694202883-46e7448c1b26?w=1200&q=80",
  ],
  "Tunisia": [
    "https://images.unsplash.com/photo-1590069261209-f8e9b8642343?w=1200&q=80",
    "https://images.unsplash.com/photo-1564694202883-46e7448c1b26?w=1200&q=80",
  ],
  "Sénégal": [
    "https://images.unsplash.com/photo-1589561253898-768105ca91a8?w=1200&q=80",
  ],
  "Senegal": [
    "https://images.unsplash.com/photo-1589561253898-768105ca91a8?w=1200&q=80",
  ],
  "Maurice": [
    "https://images.unsplash.com/photo-1540202404-a2f29016b523?w=1200&q=80",
    "https://images.unsplash.com/photo-1586500036706-41963de24d8b?w=1200&q=80",
  ],
  "Mauritius": [
    "https://images.unsplash.com/photo-1540202404-a2f29016b523?w=1200&q=80",
    "https://images.unsplash.com/photo-1586500036706-41963de24d8b?w=1200&q=80",
  ],
  "Réunion": [
    "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?w=1200&q=80",
  ],
  "Reunion": [
    "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?w=1200&q=80",
  ],
  
  // Americas
  "États-Unis": [
    "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=1200&q=80",
    "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&q=80",
    "https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=1200&q=80",
  ],
  "United States": [
    "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=1200&q=80",
    "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&q=80",
    "https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=1200&q=80",
  ],
  "USA": [
    "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=1200&q=80",
    "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&q=80",
    "https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=1200&q=80",
  ],
  "Canada": [
    "https://images.unsplash.com/photo-1517935706615-2717063c2225?w=1200&q=80",
    "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=1200&q=80",
  ],
  "Mexique": [
    "https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?w=1200&q=80",
    "https://images.unsplash.com/photo-1547995886-6dc09384c6e6?w=1200&q=80",
  ],
  "Mexico": [
    "https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?w=1200&q=80",
    "https://images.unsplash.com/photo-1547995886-6dc09384c6e6?w=1200&q=80",
  ],
  "Cuba": [
    "https://images.unsplash.com/photo-1500759285222-a95626b934cb?w=1200&q=80",
    "https://images.unsplash.com/photo-1570299437488-d430e1e677c7?w=1200&q=80",
  ],
  "Costa Rica": [
    "https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=1200&q=80",
    "https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b?w=1200&q=80",
  ],
  "Pérou": [
    "https://images.unsplash.com/photo-1526392060635-9d6019884377?w=1200&q=80",
    "https://images.unsplash.com/photo-1580619305218-8423a7ef79b4?w=1200&q=80",
  ],
  "Peru": [
    "https://images.unsplash.com/photo-1526392060635-9d6019884377?w=1200&q=80",
    "https://images.unsplash.com/photo-1580619305218-8423a7ef79b4?w=1200&q=80",
  ],
  "Brésil": [
    "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=1200&q=80",
    "https://images.unsplash.com/photo-1516306580123-e6e52b1b7b5f?w=1200&q=80",
  ],
  "Brazil": [
    "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=1200&q=80",
    "https://images.unsplash.com/photo-1516306580123-e6e52b1b7b5f?w=1200&q=80",
  ],
  "Argentine": [
    "https://images.unsplash.com/photo-1518659526054-190340b32735?w=1200&q=80",
    "https://images.unsplash.com/photo-1612294037637-ec328d0e075e?w=1200&q=80",
  ],
  "Argentina": [
    "https://images.unsplash.com/photo-1518659526054-190340b32735?w=1200&q=80",
    "https://images.unsplash.com/photo-1612294037637-ec328d0e075e?w=1200&q=80",
  ],
  "Chili": [
    "https://images.unsplash.com/photo-1478827536114-da961b7f86d2?w=1200&q=80",
    "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1200&q=80",
  ],
  "Chile": [
    "https://images.unsplash.com/photo-1478827536114-da961b7f86d2?w=1200&q=80",
    "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1200&q=80",
  ],
  "Colombie": [
    "https://images.unsplash.com/photo-1518639192441-8fce0a366e2e?w=1200&q=80",
    "https://images.unsplash.com/photo-1533702165324-66678e2069b2?w=1200&q=80",
  ],
  "Colombia": [
    "https://images.unsplash.com/photo-1518639192441-8fce0a366e2e?w=1200&q=80",
    "https://images.unsplash.com/photo-1533702165324-66678e2069b2?w=1200&q=80",
  ],
  "Équateur": [
    "https://images.unsplash.com/photo-1510537490673-5bba4f2e6b0f?w=1200&q=80",
  ],
  "Ecuador": [
    "https://images.unsplash.com/photo-1510537490673-5bba4f2e6b0f?w=1200&q=80",
  ],
  "Bolivie": [
    "https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=1200&q=80",
  ],
  "Bolivia": [
    "https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=1200&q=80",
  ],
  
  // Oceania
  "Australie": [
    "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=1200&q=80",
    "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=1200&q=80",
    "https://images.unsplash.com/photo-1529108190281-9a4f620bc2d8?w=1200&q=80",
  ],
  "Australia": [
    "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=1200&q=80",
    "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=1200&q=80",
    "https://images.unsplash.com/photo-1529108190281-9a4f620bc2d8?w=1200&q=80",
  ],
  "Nouvelle-Zélande": [
    "https://images.unsplash.com/photo-1469521669194-babb45599def?w=1200&q=80",
    "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=1200&q=80",
    "https://images.unsplash.com/photo-1508193638397-1c4234db14d8?w=1200&q=80",
  ],
  "New Zealand": [
    "https://images.unsplash.com/photo-1469521669194-babb45599def?w=1200&q=80",
    "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=1200&q=80",
    "https://images.unsplash.com/photo-1508193638397-1c4234db14d8?w=1200&q=80",
  ],
  "Polynésie française": [
    "https://images.unsplash.com/photo-1589197331516-4d84b72ebee3?w=1200&q=80",
    "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=1200&q=80",
  ],
  "French Polynesia": [
    "https://images.unsplash.com/photo-1589197331516-4d84b72ebee3?w=1200&q=80",
    "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=1200&q=80",
  ],
  "Fidji": [
    "https://images.unsplash.com/photo-1512100356356-de1b84283e18?w=1200&q=80",
  ],
  "Fiji": [
    "https://images.unsplash.com/photo-1512100356356-de1b84283e18?w=1200&q=80",
  ],
  
  // Middle East
  "Turquie": [
    "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=1200&q=80",
    "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=1200&q=80",
    "https://images.unsplash.com/photo-1589561454226-796a8aa89b05?w=1200&q=80",
  ],
  "Turkey": [
    "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=1200&q=80",
    "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=1200&q=80",
    "https://images.unsplash.com/photo-1589561454226-796a8aa89b05?w=1200&q=80",
  ],
  "Émirats arabes unis": [
    "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200&q=80",
    "https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1200&q=80",
  ],
  "United Arab Emirates": [
    "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200&q=80",
    "https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1200&q=80",
  ],
  "Dubaï": [
    "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200&q=80",
    "https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1200&q=80",
  ],
  "Dubai": [
    "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200&q=80",
    "https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1200&q=80",
  ],
  "Jordanie": [
    "https://images.unsplash.com/photo-1579606032821-4e6161c81571?w=1200&q=80",
    "https://images.unsplash.com/photo-1580834341580-8c17a3a630ca?w=1200&q=80",
  ],
  "Jordan": [
    "https://images.unsplash.com/photo-1579606032821-4e6161c81571?w=1200&q=80",
    "https://images.unsplash.com/photo-1580834341580-8c17a3a630ca?w=1200&q=80",
  ],
  "Israël": [
    "https://images.unsplash.com/photo-1552423310-ba74b0bfced7?w=1200&q=80",
    "https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1200&q=80",
  ],
  "Israel": [
    "https://images.unsplash.com/photo-1552423310-ba74b0bfced7?w=1200&q=80",
    "https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1200&q=80",
  ],
  "Oman": [
    "https://images.unsplash.com/photo-1559304787-83a8e8f15598?w=1200&q=80",
  ],
  
  // Caribbean
  "République dominicaine": [
    "https://images.unsplash.com/photo-1569700953045-fcd34f8ff855?w=1200&q=80",
  ],
  "Dominican Republic": [
    "https://images.unsplash.com/photo-1569700953045-fcd34f8ff855?w=1200&q=80",
  ],
  "Jamaïque": [
    "https://images.unsplash.com/photo-1533462758985-d7d0e95fcae0?w=1200&q=80",
  ],
  "Jamaica": [
    "https://images.unsplash.com/photo-1533462758985-d7d0e95fcae0?w=1200&q=80",
  ],
  "Martinique": [
    "https://images.unsplash.com/photo-1584735935682-2f2b69dff9d2?w=1200&q=80",
  ],
  "Guadeloupe": [
    "https://images.unsplash.com/photo-1620121684840-edffcfc4b878?w=1200&q=80",
  ],
  "Bahamas": [
    "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=1200&q=80",
  ],
  "Maldives": [
    "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=1200&q=80",
    "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=1200&q=80",
  ],
  "Seychelles": [
    "https://images.unsplash.com/photo-1589979481223-deb893043163?w=1200&q=80",
  ],
};

// Fallback images for countries not in the list
const fallbackImages = [
  "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1200&q=80",
  "https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=1200&q=80",
  "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=1200&q=80",
];

/**
 * Simple hash function to get a consistent index from a string
 */
const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

/**
 * Get a default cover image URL based on country name
 * Uses trip ID or title to consistently select from multiple images per country
 * @param countries - Country name or array of country names
 * @param seed - Optional seed (e.g., trip ID or title) to consistently select an image
 */
export const getDefaultCoverImage = (countries: string | string[], seed?: string): string => {
  const countryList = Array.isArray(countries) ? countries : countries.split(",").map(c => c.trim());
  
  for (const country of countryList) {
    const images = defaultCoverImages[country];
    if (images && images.length > 0) {
      if (seed) {
        const index = hashString(seed) % images.length;
        return images[index];
      }
      return images[0];
    }
    
    // Try with first letter uppercase
    const normalized = country.charAt(0).toUpperCase() + country.slice(1).toLowerCase();
    const normalizedImages = defaultCoverImages[normalized];
    if (normalizedImages && normalizedImages.length > 0) {
      if (seed) {
        const index = hashString(seed) % normalizedImages.length;
        return normalizedImages[index];
      }
      return normalizedImages[0];
    }
  }
  
  // Use seed to vary fallback image too
  if (seed) {
    const index = hashString(seed) % fallbackImages.length;
    return fallbackImages[index];
  }
  
  return fallbackImages[0];
};

export default defaultCoverImages;
